module.exports = __webpack_public_path__ + "img/edit.762b1c9d.svg";